"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK = void 0;
const date_fns_1 = require("date-fns");
const User = [
    {
        id: 0,
        email: "mock@realsprint.com",
        name: {
            first: "Mock",
            last: "Sörensson",
            custom: "MockS01",
        },
        imageUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
        quote: "Just did this workout two days in a row and SUPER proud of myself. Thank you so much - the euphoria feels so good",
        roles: [],
        created: null,
        updated: null,
        programs: null,
        instructorProfile: null,
        partnerProfile: null,
        followedInstructors: null,
        signUpCodes: null,
        followedPrograms: null,
        bookedSessions: null,
        answers: null,
        tosVersion: null,
        password: null,
        facebookId: null,
        googleId: null,
        appleId: null,
        userVerificationCodes: null,
        chatMessages: [],
        stripeCustomerId: null,
        stripeProducts: [],
        liveSessionStatistics: [],
        favouritedLiveSessions: [],
        expoPushNotificationTokens: [],
        favouritedPrograms: null,
        recruitedBy: null,
        recruitedById: null,
        recruitments: null,
        muteExpiration: null,
        sessions: null,
        competitionRounds: null,
        balance: null,
        acceptAdvertisment: false,
        bookingTimestamps: null,
        favouritedPlaylists: null,
        churned: false,
    },
];
const Instructor = [
    {
        id: 0,
        name: {
            first: "Moa",
            last: "Westman",
            custom: "MoaW01",
        },
        quote: "There is no competition. Focus on being a better version of your self",
        imageUrl: "/assets/trainer-images/moa-profile.jpg",
        created: null,
        updated: null,
        roles: null,
        programs: null,
        instructorProfile: null,
        partnerProfile: null,
        followedInstructors: null,
        signUpCodes: null,
        followedPrograms: null,
        bookedSessions: null,
        answers: null,
        chatMessages: [],
        liveSessionStatistics: [],
        favouritedLiveSessions: null,
        favouritedPrograms: null,
        recruitedBy: null,
        recruitedById: null,
        recruitments: null,
        muteExpiration: null,
        sessions: null,
        acceptAdvertisment: false,
        bookingTimestamps: null,
        favouritedPlaylists: null,
        churned: false,
    },
];
const Program = [
    {
        id: 0,
        title: "Slow down yoga",
        instructor: Instructor[0],
        rating: 5,
        imageUrl: "/assets/trainer-images/moa-169.jpg",
        lobbyMusic: "/assets/audio/lobby-moa.mp3",
        level: "intermediate",
        duration: 15,
        instructorId: null,
        description: null,
        goodToKnow: null,
        followers: null,
        posterUrl: null,
        videoUrl: null,
        sessions: null,
        vods: null,
        created: null,
        updated: null,
        deletedAt: null,
        favouringUsers: null,
        programTags: null,
        categories: null,
    },
];
const FullProgram = {
    id: 12,
    created: null,
    followers: null,
    instructorId: null,
    sessions: null,
    updated: null,
    vods: null,
    favouringUsers: null,
    title: "Ett testprogram",
    description: "test program description",
    goodToKnow: ["good to know 1", "good to know 2"],
    rating: null,
    imageUrl: "/assets/kvix-default-avatar.svg",
    posterUrl: null,
    lobbyMusic: null,
    duration: 20,
    level: "intermediate",
    deletedAt: null,
    programTags: null,
    categories: null,
    instructor: {
        bookedSessions: null,
        id: 7,
        imageUrl: "/assets/kvix-default-avatar.svg",
        created: new Date("2020-01-13T13:07:34.539Z"),
        name: {
            first: "Kevin",
            last: "Kvix",
            custom: null,
        },
        roles: [],
        updated: new Date("2020-01-13T13:07:34.539Z"),
        quote: "test",
        followedInstructors: null,
        signUpCodes: null,
        followedPrograms: null,
        instructorProfile: null,
        partnerProfile: null,
        programs: null,
        answers: null,
        chatMessages: [],
        liveSessionStatistics: [],
        favouritedLiveSessions: null,
        favouritedPrograms: null,
        recruitedBy: null,
        recruitedById: null,
        recruitments: null,
        muteExpiration: null,
        sessions: null,
        acceptAdvertisment: false,
        bookingTimestamps: null,
        favouritedPlaylists: null,
        churned: false,
    },
};
const __generateSessions = () => {
    const now = new Date();
    const in5minutes = (0, date_fns_1.addMinutes)(now, 5);
    const in35minutes = (0, date_fns_1.addMinutes)(now, 35);
    const in20minutes = (0, date_fns_1.addMinutes)(now, 20);
    const in60minutes = (0, date_fns_1.addMinutes)(now, 60);
    const in1hourAnd45minutes = (0, date_fns_1.addHours)((0, date_fns_1.setMinutes)(now, 45), 1);
    const in2hoursAnd15minutes = (0, date_fns_1.addHours)((0, date_fns_1.setMinutes)(now, 15), 2);
    return [
        {
            id: 0,
            start: new Date("Wed Nov 27 2019 20:15:00 GMT+0100 (Central European Standard Time)"),
            end: new Date("Wed Nov 27 2019 20:30:00 GMT+0100 (Central European Standard Time)"),
            program: Program[0],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 1,
            start: (0, date_fns_1.addMinutes)(now, 1),
            end: (0, date_fns_1.addMinutes)(now, 6),
            program: Program[0],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 2,
            start: (0, date_fns_1.addMinutes)(now, 2),
            end: (0, date_fns_1.addMinutes)(now, 22),
            program: Program[1],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 3,
            start: in1hourAnd45minutes,
            end: in2hoursAnd15minutes,
            program: Program[2],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 4,
            start: (0, date_fns_1.addDays)(in5minutes, 1),
            end: (0, date_fns_1.addDays)(in35minutes, 1),
            program: Program[3],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 5,
            start: (0, date_fns_1.addDays)(in20minutes, 2),
            end: (0, date_fns_1.addDays)(in60minutes, 2),
            program: Program[4],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 6,
            start: (0, date_fns_1.addDays)(in1hourAnd45minutes, 6),
            end: (0, date_fns_1.addDays)(in2hoursAnd15minutes, 6),
            program: Program[5],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
        {
            id: 7,
            start: (0, date_fns_1.addDays)(in20minutes, 3),
            end: (0, date_fns_1.addDays)(in60minutes, 3),
            program: Program[6],
            programId: null,
            instructor: Instructor[0],
            instructorId: null,
            title: "",
            created: null,
            updated: null,
            answers: null,
            bookedUsers: null,
            state: null,
            thumbnailUrl: null,
            favouringUsers: null,
            deletedAt: null,
            competitionRound: null,
            dalsStream: null,
            dalsStreamId: null,
            wowzaStream: null,
            wowzaStreamId: null,
        },
    ];
};
const Message = [
    {
        id: 0,
        author: {
            name: {
                first: "Dana",
                last: "Kopřivová",
            },
            imageUrl: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
            joined: null,
        },
        submitted: new Date("2019-12-12"),
        text: "Hey Malin!",
    },
    {
        id: 1,
        author: {
            name: {
                first: "Neville",
                last: "Griffin",
            },
            imageUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
            joined: null,
        },
        submitted: new Date("2019-12-09"),
        text: "See ya!",
    },
    {
        id: 2,
        author: {
            name: {
                first: "Qingyang",
                last: "Zhang",
            },
            imageUrl: "https://cdn.pixabay.com/photo/2015/11/20/17/29/person-1053543_960_720.jpg",
            joined: null,
        },
        submitted: new Date("2019-11-14"),
        text: "Thanks for taking part guys, see you next week!",
    },
    {
        id: 3,
        author: {
            name: {
                first: "Alex",
                last: "Edwards",
            },
            imageUrl: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
            joined: null,
        },
        submitted: new Date("2019-10-22"),
        text: "Best workouts for home .. I absolutely seen a big improvement in just a week....very convenient & challenging .Thank you !! you’re absolutely awesome",
    },
    {
        id: 4,
        author: {
            name: {
                first: "Mgbankwo",
                last: "Orjee",
            },
            imageUrl: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
            joined: null,
        },
        submitted: new Date("2019-10-14"),
        text: "I'm broken hahahh",
    },
];
const Comment = [
    {
        id: 0,
        user: {
            name: {
                first: "Dana",
                last: "Kopřivová",
                custom: "DanaK1",
            },
            imageUrl: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
        },
        created: new Date("2019-12-12"),
        rating: 4,
        comment: "Just did this workout two days in a row and SUPER proud of myself. Thank you so much - the euphoria feels so good",
    },
    {
        id: 1,
        user: {
            name: {
                first: "Neville",
                last: "Griffin",
                custom: "NevilleG",
            },
            imageUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a0/Pierre-Person.jpg",
        },
        created: new Date("2019-12-09"),
        rating: 2,
        comment: "15 minutes workout and the rest I was dead on the couch, so my mind pretty much did the rest!",
    },
    {
        id: 2,
        user: {
            name: {
                first: "Qingyang",
                last: "Zhang",
                custom: "QingyangZ",
            },
            imageUrl: "https://cdn.pixabay.com/photo/2015/11/20/17/29/person-1053543_960_720.jpg",
        },
        created: new Date("2019-11-14"),
        rating: 4,
        comment: "So funny - this isn’t nearly the hardest workout of yours I’ve done but it makes me sweat like NO OTHER!",
    },
    {
        id: 3,
        user: {
            name: {
                first: "Alex",
                last: "Edwards",
                custom: "AlexE1",
            },
            imageUrl: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
        },
        created: new Date("2019-10-22"),
        rating: 3,
        comment: "Best workouts for home .. I absolutely seen a big improvement in just a week....very convenient & challenging .Thank you !! you’re absolutely awesome",
    },
    {
        id: 4,
        user: {
            name: {
                first: "Mgbankwo",
                last: "Orjee",
                custom: "MgbankwoO",
            },
            imageUrl: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
        },
        created: new Date("2019-10-14"),
        rating: 5,
        comment: "Just completed this workout, wow! I was dripping sweat",
    },
];
const Category = [
    {
        id: 0,
        name: "Cardio",
    },
    {
        id: 1,
        name: "Strength",
    },
    {
        id: 2,
        name: "Balance",
    },
    {
        id: 3,
        name: "Flexibility",
    },
];
exports.MOCK = {
    User,
    Program,
    FullProgram,
    Session: __generateSessions(),
    Message,
    Comment,
    Category,
};
//# sourceMappingURL=Mock.js.map